module.exports = __webpack_public_path__ + "static/media/icon-rest-burger.2ff387f3.png";